<template>
  <div>
    <p class="md-display-1">Fotos</p>
    <div class="row">
      <div v-for="(foto, i) in fotos" :key="i" class="col-6 mt-4">
        <img :src="foto" alt="Foto" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListagemFotosSig',
  props: {
    fotos: Array,
  },
}
</script>

<style scoped></style>
